<script lang="ts">
    import dayjs from 'dayjs';
    import clockStore from '../../../utils/clock.js';

    export let format = 'hh:mm';
    // update every 1sec
    const clock = clockStore({ interval: 1000 });
</script>

<div class="time">
    {dayjs($clock).format(format)}
</div>
